import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class GroupRefreshService {
    // This can be scrapped once project is upgraded to Angular 5, replaced with router refresh code
    // Needed at present because no other way to pass event from program component to group component
    // ...to refresh group list.
    public refreshGroupList: Subject<Boolean> = new Subject<Boolean>();
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/group-refresh.service.ts